import React, { useState } from "react";
import "./Create.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Create = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const history = useNavigate();

  const header = { "Access-Control-Allow-Origin": "*" };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("clicked");
    axios
      .post(
        "https://64294bc6ebb1476fcc466541.mockapi.io/crudpracticee/crud-practice",
        {
          name: name,
          email: email,
          header,
        }
      )

      .then(() => {
        history("/read");
      });
  };
  return (
    <>
      <form className="box">
        <div className="d-flex justify-content-between m-2">
          <h2>Create</h2>
          <Link to="/read">
          <button className="btn btn-primary">Show data</button>
          </Link>
        </div>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Email address</label>
          <input
            type="email"
            className="form-control"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary mx-2"
          onClick={handleSubmit}
        >
          Submit
        </button>

        <Link to={"/read"}>
        <button
          className="btn btn-secondary mx-2"
        >
          Back
        </button>
        </Link>
      </form>
    </>
  );
};

export default Create;
